import { Directive, HostListener, Input } from '@angular/core';
import { TranslatorService } from '../../services/utils/translator.service';

@Directive({
    selector: '[leadinHelp]'
})
export class LeadinHelpDirective {

    constructor(private readonly translatorService: TranslatorService) { }

    @Input('leadinHelp') token: string;
    @Input('leadinHelpInfo') info: string;
    @Input() iconHelp: string;
    @Input() iconInfo: string;
    @Input() idContainer: string;

    @HostListener('mouseenter') onMouseEnter() {

        if (this.idContainer) {

        } else {
            this.setListenerForDefaultContainer();
        }
    }

    @HostListener('mouseleave') onMouseLeave() {
        // if (!this.idContainer) {
        //     document.getElementById('leadin-help-container').classList.remove('show');
        // }
    }

    private setListenerForDefaultContainer() {
        document.getElementById('leadin-help-text').innerHTML = '';
        document.getElementById('leadin-help-info-text').innerHTML = '';

        if (this.info) {
            document.getElementById('leadin-help-info-icon').classList.add(...['fas', 'fa-info-circle']);
            document.getElementById('leadin-help-info-text').innerHTML += this.translatorService.trans(this.info);
        } else {
            document.getElementById('leadin-help-info-icon').classList.remove(...['fas', 'fa-info-circle']);
        }

        if (this.iconHelp) {
            document.getElementById('leadin-help-icon').classList.add(...this.iconHelp.split(' '));
        } else {
            document.getElementById('leadin-help-icon').classList.add(...['fas', 'fa-question-circle']);
        }
        document.getElementById('leadin-help-text').innerHTML += this.translatorService.trans(this.token);
       // document.getElementById('leadin-help-container').classList.add('show');
    }

}
